import {
  bridgeCallsRuntime,
  type CallsRuntimeBridgeResult,
  type CallsRuntimeBridgeStatus,
} from './CallsRuntimeBridge';

export type CallsRuntimeEvidenceOutcome =
  | 'runtime-authorized'
  | 'runtime-denied';

export interface CallsRuntimeEvidenceRecord {
  readonly evidenceId: string;
  readonly governor: string;
  readonly governorId: string;
  readonly governorKey: string;
  readonly domain: string;
  readonly lifecycle: string;
  readonly evidenceSource: 'calls-runtime-evidence-pipeline';
  readonly upstreamEvidenceSource:
    CallsRuntimeBridgeResult['evidenceSource'];
  readonly constitutionalEvidenceSource:
    CallsRuntimeBridgeResult['upstreamEvidenceSource'];
  readonly bridgeStatus: CallsRuntimeBridgeStatus;
  readonly outcome: CallsRuntimeEvidenceOutcome;
  readonly execution:
    CallsRuntimeBridgeResult['execution'];
  readonly executionAuthorized: boolean;
  readonly decision:
    CallsRuntimeBridgeResult['decision'];
  readonly reasonCode: string;
  readonly reason: string;
  readonly evidenceCapturedAt: string;
  readonly pipelineCapturedAt: string;
}

function createCallsRuntimeEvidenceId(
  bridge: CallsRuntimeBridgeResult,
  pipelineCapturedAt: string,
): string {
  return [
    'calls-runtime',
    bridge.governorId,
    bridge.reasonCode,
    pipelineCapturedAt,
  ]
    .join(':')
    .replace(/[^a-zA-Z0-9:_-]/g, '-');
}

function mapCallsRuntimeEvidenceOutcome(
  executionAuthorized: boolean,
): CallsRuntimeEvidenceOutcome {
  return executionAuthorized
    ? 'runtime-authorized'
    : 'runtime-denied';
}

export function captureCallsRuntimeEvidence():
  CallsRuntimeEvidenceRecord {
  const bridge = bridgeCallsRuntime();
  const pipelineCapturedAt = new Date().toISOString();

  return Object.freeze({
    evidenceId: createCallsRuntimeEvidenceId(
      bridge,
      pipelineCapturedAt,
    ),
    governor: bridge.governor,
    governorId: bridge.governorId,
    governorKey: bridge.governorKey,
    domain: bridge.domain,
    lifecycle: bridge.lifecycle,
    evidenceSource:
      'calls-runtime-evidence-pipeline',
    upstreamEvidenceSource:
      bridge.evidenceSource,
    constitutionalEvidenceSource:
      bridge.upstreamEvidenceSource,
    bridgeStatus: bridge.status,
    outcome: mapCallsRuntimeEvidenceOutcome(
      bridge.executionAuthorized,
    ),
    execution: bridge.execution,
    executionAuthorized:
      bridge.executionAuthorized,
    decision: bridge.decision,
    reasonCode: bridge.reasonCode,
    reason: bridge.reason,
    evidenceCapturedAt:
      bridge.evidenceCapturedAt,
    pipelineCapturedAt,
  });
}
